// Created by hejikun on 2017/11/2 0002.
let flowers = [
  {
    path: '/flowers',
    name: '鲜花服务',
    component: () => import('@/pages/flowers/index')
  },
  {
    path: '/flowers_detail',
    name: '鲜花服务',
    component: () => import('@/pages/flowers/flowers_detail')
  },
  {
    path: '/flowers_order',
    name: '确认订单',
    component: () => import('@/pages/flowers/flowers_order')
  },
  {
    path: '/flowers_list',
    name: '鲜花列表',
    component: () => import('@/pages/flowers/flowers_list')
  },
  {
    path: '/flowers_recipients_list',
    name: '收寄货人',
    component: () => import('@/pages/flowers/recipients_list')
  },
  {
    path: '/flowers_add_recipients',
    name: '新增收寄货人',
    component: () => import('@/pages/flowers/add_recipients')
  },
  {
    path: '/flowers_order_list',
    name: '鲜花订单',
    component: () => import('@/pages/flowers/flowers_order_list')
  },
  {
    path: '/flowers_order_detail',
    name: '鲜花订单详情',
    component: () => import('@/pages/flowers/flowers_order_detail')
  },
  {
    path: '/flowers_hot_type',
    name: '花品花束',
    component: () => import('@/pages/flowers/flowers_hot_type')
  }
]

export default flowers
